import { LOCALE } from "core/interfaces";

import { itemPrototypeNormalize } from "~/common/helpers/item-prototype-adapter";
import { materialNormalize } from "~/common/helpers/material-adapter";
import { sizeNormalize } from "~/common/helpers/size-adapter";
import type { Item, ItemAdapted } from "~/common/interfaces/entities/item.interface";

/** @warn method could work not as expected */
export const itemDenormalize = (): any => {
	return {};
};

export const itemNormalize = (locale: Ref<LOCALE>, item: Item): ItemAdapted => {
	const { size, price, discountedPrice, itemPrototype, material, ...rest } = item;

	return {
		...rest,
		price: {
			discountedPrice,
			price
		},
		discountedPrice,
		itemPrototype: itemPrototypeNormalize(locale, itemPrototype),
		material: materialNormalize(locale, material),
		size: sizeNormalize(size)
	};
};
